import { Navbar } from "@/components/Navbar";
import { Marquee } from "@/components/Marquee";
import { StickyJoinBar } from "@/components/StickyJoinBar";
import HeroV2 from "@/sections/v2/HeroV2";
import ExecutionGapV2 from "@/sections/v2/ExecutionGapV2";
import GamePlanV2 from "@/sections/v2/GamePlanV2";
import Comparison from "@/sections/v2/Comparison";
import PeeOSV2 from "@/sections/v2/PeeOSV2";
import LifecycleV2 from "@/sections/v2/LifecycleV2";
import DoNothingV2 from "@/sections/v2/DoNothingV2";
import AlertsV2 from "@/sections/v2/AlertsV2";
import AnalyticsV2 from "@/sections/v2/AnalyticsV2";
import IdentityV2 from "@/sections/v2/IdentityV2";
import WhoThisIsFor from "@/sections/v2/WhoThisIsFor";
import CommunityV2 from "@/sections/v2/CommunityV2";
import PathV2 from "@/sections/v2/PathV2";
import ResultsV2 from "@/sections/v2/ResultsV2";
import WhyPeeExists from "@/sections/v2/WhyPeeExists";
import PricingV2 from "@/sections/v2/PricingV2";
import FaqV2 from "@/sections/v2/FaqV2";
import FinalCtaV2 from "@/sections/v2/FinalCtaV2";
import FooterV2 from "@/sections/v2/FooterV2";

export default function HomeV2() {
  return (
    <>
      <Navbar />
      <main>
        <HeroV2 />
        <Marquee />
        <ExecutionGapV2 />
        <GamePlanV2 />
        <Comparison />
        <PeeOSV2 />
        <LifecycleV2 />
        <DoNothingV2 />
        <AlertsV2 />
        <AnalyticsV2 />
        <IdentityV2 />
        <WhoThisIsFor />
        <CommunityV2 />
        <PathV2 />
        <ResultsV2 />
        <WhyPeeExists />
        <PricingV2 />
        <FaqV2 />
        <FinalCtaV2 />
      </main>
      <FooterV2 />
      <StickyJoinBar />
    </>
  );
}
